import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchProductStatuses, deleteProductStatus } from "actions/productStatus";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import Table from "./Table";
import Pagination from "components/Pagination";

class ProductStatusIndex extends Component {
  componentDidMount() {
    this.props.fetchProductStatuses();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchProductStatuses({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { productStatusURL: productStatus_url } = this.props.match.params;
    this.props.fetchProductStatuses({ productStatus_url, page, ...this.search });
  };

  handleProductStatusDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteProductStatusProcess(id);
      },
      title: "Delete Product Status",
      body: "Are you sure you want to delete this Product Status?"
    });
  };

  deleteProductStatusProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteProductStatus, match } = this.props;
    const { productStatusURL: productStatus_url } = match.params;
    deleteProductStatus(id, { productStatus_url })
      .then(() => {
        this.props.fetchProductStatuses({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Product Status Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { productStatuses } = this.props;

    return (
      <div>
        <div className="box">
          <Table productStatuses={productStatuses} onClickDelete={this.handleProductStatusDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={productStatuses.current_page}
            lastPage={productStatuses.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authProductStatus, productStatuses, confirmationPopupActive }) => ({
  authProductStatus,
  productStatuses,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchProductStatuses, deleteProductStatus, toggleconfirmationPopup, toggleNotification }
)(ProductStatusIndex);



// WEBPACK FOOTER //
// ./src/pages/ProductStatus/Index/index.js